import React from "react";
import { FaMapPin } from "react-icons/fa6";
import { Address } from "../hooks/adress";
import { useTranslation } from "react-i18next";
import { renderHTML } from "../hooks/htmlToText";
import { useSectionObserver } from "../hooks/useSectionObserver";

export const TableTermsContent = () => {
  const { t } = useTranslation();
  useSectionObserver([
    "our-services",
    "intellectual-property-rights",
    "user-representations",
    "purchases-payment",
    "prohibited-activities",
    "third-party-content",
    "services-management",
    "privacy-policy",
    "term-termination",
    "modifications-interruptions",
    "governing-law",
    "dispute-resolution",
    "corrections",
    "disclaimer",
    "limitations-liability",
    "indemnification",
    "user-data",
    "electronic-communications",
    "california-users",
    "miscellaneous",
    "contact-us",
  ]);

  return (
    <div className="flex flex-col gap-5">
      <div
        id={"our-services"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          1. {String(t("termsPage.table.t1"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.first.p1")))}</p>
          <p>
            <p>{renderHTML(String(t("termsPage.tableContent.first.p2")))}</p>
          </p>
        </div>
      </div>
      <div
        id={"intellectual-property-rights"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          2. {String(t("termsPage.table.t2"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <div>
            <p className="font-600 text-16px md:text-[18px] my-[10px]">
              <p>
                {renderHTML(
                  String(t("termsPage.tableContent.second.subtitle1"))
                )}
              </p>
            </p>
            <div className="gap-2 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
              <p>{renderHTML(String(t("termsPage.tableContent.second.p1")))}</p>
              <p>
                <p>
                  {renderHTML(String(t("termsPage.tableContent.second.p2")))}
                </p>
              </p>
              <p>
                <p>
                  {renderHTML(String(t("termsPage.tableContent.second.p3")))}
                </p>
              </p>
            </div>
          </div>
          <div>
            <p className="font-600 text-16px md:text-[18px] my-[10px]">
              {renderHTML(String(t("termsPage.tableContent.second.subtitle2")))}
            </p>
            <div className="gap-2 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
              <div>
                {renderHTML(String(t("termsPage.tableContent.second.p4")))}
                <ul className="list-disc ml-[30px]">
                  <li>
                    {renderHTML(String(t("termsPage.tableContent.second.ol1")))}
                  </li>
                  <li>
                    {renderHTML(String(t("termsPage.tableContent.second.ol2")))}
                  </li>
                </ul>
              </div>
              <p>{renderHTML(String(t("termsPage.tableContent.second.p5")))}</p>
              <p>{renderHTML(String(t("termsPage.tableContent.second.p6")))}</p>
              <p>{renderHTML(String(t("termsPage.tableContent.second.p7")))}</p>
              <p>{renderHTML(String(t("termsPage.tableContent.second.p8")))}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        id={"user-representations"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          3.{String(t("termsPage.table.t3"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <div>
            {renderHTML(String(t("termsPage.tableContent.third.p1")))}
            <ol className="list-auto ml-[30px]">
              <li>
                {renderHTML(String(t("termsPage.tableContent.third.ol1")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.third.ol2")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.third.ol3")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.third.ol4")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.third.ol5")))}
              </li>
            </ol>
          </div>
          <p>{renderHTML(String(t("termsPage.tableContent.third.p2")))}</p>
        </div>
      </div>
      <div
        id={"purchases-payment"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          4. {String(t("termsPage.table.t4"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p className="font-600">
            {renderHTML(String(t("termsPage.tableContent.fourth.subtitle")))}
          </p>
          <p>{renderHTML(String(t("termsPage.tableContent.fourth.p1")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.fourth.p2")))}</p>
        </div>
      </div>
      <div
        id={"prohibited-activities"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          5. {String(t("termsPage.table.t5"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.fifth.p1")))}</p>
          <p className="font-600 text-16px md:text-[18px] my-[10px]">
            {renderHTML(String(t("termsPage.tableContent.fifth.subtitle")))}
          </p>
          <ul className="list-disc ml-[30px]">
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol1")))}</li>
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol2")))}</li>
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol3")))}</li>
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol4")))}</li>
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol5")))}</li>
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol6")))}</li>
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol7")))}</li>
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol8")))}</li>
            <li>{renderHTML(String(t("termsPage.tableContent.fifth.ol9")))}</li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol10")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol11")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol12")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol13")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol14")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol15")))}
              to you.
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol16")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol17")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol18")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol19")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol20")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol21")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.fifth.ol22")))}
            </li>
          </ul>
        </div>
      </div>
      <div
        id={"third-party-content"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          6. {String(t("termsPage.table.t6"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.sixth.p1")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.sixth.p2")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.sixth.p3")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.sixth.p4")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.sixth.p5")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.sixth.p6")))}</p>
        </div>
      </div>
      <div
        id={"services-management"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          7. {String(t("termsPage.table.t7"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.seventh.p1")))}</p>
          <ol className="list-auto ml-[30px]">
            <li>
              {renderHTML(String(t("termsPage.tableContent.seventh.ol1")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.seventh.ol2")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.seventh.ol3")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.seventh.ol4")))}
            </li>
            <li>
              {renderHTML(String(t("termsPage.tableContent.seventh.ol5")))}
            </li>
          </ol>
        </div>
      </div>
      <div
        id={"privacy-policy"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          8. {String(t("termsPage.table.t8"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.eighth.p1")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.eighth.p2")))}</p>
        </div>
      </div>
      <div
        id={"term-termination"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          9. {String(t("termsPage.table.t9"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.ninth.p1")))}</p>
          <p className="font-600">
            {renderHTML(String(t("termsPage.tableContent.ninth.p2")))}
          </p>
          <p className="font-600">
            {renderHTML(String(t("termsPage.tableContent.ninth.p3")))}
          </p>
          <p>{renderHTML(String(t("termsPage.tableContent.ninth.p4")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.ninth.p5")))}</p>
        </div>
      </div>
      <div
        id={"modifications-interruptions"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          10. {String(t("termsPage.table.t10"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.tenth.p1")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.tenth.p2")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.tenth.p3")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.tenth.p4")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.tenth.p5")))}</p>
        </div>
      </div>
      <div
        id={"governing-law"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          11. {String(t("termsPage.table.t11"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>
            <p>{renderHTML(String(t("termsPage.tableContent.eleventh.p1")))}</p>
          </p>
          <p>
            <p>{renderHTML(String(t("termsPage.tableContent.eleventh.p2")))}</p>
          </p>
          <p>
            <p>{renderHTML(String(t("termsPage.tableContent.eleventh.p3")))}</p>
          </p>
        </div>
      </div>
      <div
        id={"dispute-resolution"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          12. {String(t("termsPage.table.t12"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <div className="flex flex-col gap-2">
            <p className="font-600 text-16px md:text-[18px] my-[10px]">
              {renderHTML(
                String(t("termsPage.tableContent.twelfth.subtitle1"))
              )}
            </p>
            <p>
              {renderHTML(String(t("termsPage.tableContent.twelfth.p1.1")))}
            </p>
            <p>
              {renderHTML(String(t("termsPage.tableContent.twelfth.p1.2")))}
            </p>
            <div>
              <p>
                {renderHTML(String(t("termsPage.tableContent.twelfth.p1.3")))}
              </p>
              <p>
                {renderHTML(String(t("termsPage.tableContent.twelfth.p1.4")))}
              </p>
              <p>
                {renderHTML(String(t("termsPage.tableContent.twelfth.p1.5")))}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <p className="font-600 text-16px md:text-[18px] my-[10px]">
              {renderHTML(
                String(t("termsPage.tableContent.twelfth.subtitle2"))
              )}
            </p>
            <p>
              {renderHTML(String(t("termsPage.tableContent.twelfth.p2.1")))}
            </p>
            <p>
              {" "}
              {renderHTML(
                String(t("termsPage.tableContent.twelfth.p2.2"))
              )}{" "}
            </p>
            <ul className="list-disc ml-[30px]">
              <li>
                {renderHTML(String(t("termsPage.tableContent.twelfth.ul1")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.twelfth.ul2")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.twelfth.ul3")))}
              </li>
            </ul>
          </div>
          <div className="flex flex-col gap-2">
            <p className="font-600 text-16px md:text-[18px] my-[10px]">
              {renderHTML(
                String(t("termsPage.tableContent.twelfth.subtitle3"))
              )}
            </p>
            <div>
              {renderHTML(String(t("termsPage.tableContent.twelfth.p3.1")))}
              <ol className="list-auto ml-[30px]">
                <li>
                  {renderHTML(String(t("termsPage.tableContent.twelfth.ol1")))}
                </li>
                <li>
                  {renderHTML(String(t("termsPage.tableContent.twelfth.ol2")))}
                </li>
                <li>
                  {renderHTML(String(t("termsPage.tableContent.twelfth.ol3")))}
                </li>
              </ol>
            </div>
            <p>
              {renderHTML(String(t("termsPage.tableContent.twelfth.p3.2")))}
            </p>
            <p>
              {renderHTML(String(t("termsPage.tableContent.twelfth.p3.3")))}
            </p>
          </div>
        </div>
      </div>
      <div
        id={"corrections"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          13. {String(t("termsPage.table.t13"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <div>
            {renderHTML(String(t("termsPage.tableContent.thirteenth.p1")))}
            <ul className="list-disc ml-[30px]">
              <li>
                {renderHTML(String(t("termsPage.tableContent.thirteenth.ul1")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.thirteenth.ul2")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.thirteenth.ul3")))}
              </li>
            </ul>
          </div>
          <p>{renderHTML(String(t("termsPage.tableContent.thirteenth.p2")))}</p>
        </div>
      </div>
      <div
        id={"disclaimer"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          14. {String(t("termsPage.table.t14"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.fourteenth.p1")))}</p>
          <div>
            {renderHTML(String(t("termsPage.tableContent.fourteenth.p2")))}
            <ul className="list-disc ml-[30px] font-600">
              <li>
                {renderHTML(
                  String(t("termsPage.tableContent.fourteenth.ul1.1"))
                )}
              </li>
              <li>
                {renderHTML(
                  String(t("termsPage.tableContent.fourteenth.ul1.2"))
                )}
              </li>
              <li>
                {renderHTML(
                  String(t("termsPage.tableContent.fourteenth.ul1.3"))
                )}
              </li>
            </ul>
          </div>
          <div>
            {renderHTML(String(t("termsPage.tableContent.fourteenth.p3")))}
            <ol className="list-auto ml-[30px]">
              <li>
                {renderHTML(String(t("termsPage.tableContent.fourteenth.ol1")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.fourteenth.ol2")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.fourteenth.ol3")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.fourteenth.ol4")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.fourteenth.ol5")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.fourteenth.ol6")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.fourteenth.ol7")))}
              </li>
            </ol>
          </div>
          <div>
            {renderHTML(String(t("termsPage.tableContent.fourteenth.p4")))}
            <ul className="list-disc ml-[30px]">
              <li>
                {renderHTML(
                  String(t("termsPage.tableContent.fourteenth.ul2.1"))
                )}
              </li>
              <li>
                {renderHTML(
                  String(t("termsPage.tableContent.fourteenth.ul2.2"))
                )}
              </li>
              <li>
                {renderHTML(
                  String(t("termsPage.tableContent.fourteenth.ul2.3"))
                )}
              </li>
            </ul>
          </div>
          <p>{renderHTML(String(t("termsPage.tableContent.fourteenth.p5")))}</p>
        </div>
      </div>
      <div
        id={"limitations-liability"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          15. {String(t("termsPage.table.t15"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          {renderHTML(String(t("termsPage.tableContent.fifteenth.p1")))}
        </div>
      </div>
      <div
        id={"indemnification"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          16. {String(t("termsPage.table.t16"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <div>
            {renderHTML(String(t("termsPage.tableContent.sixteenth.p1")))}
            <ol className="list-auto ml-[30px]">
              <li>
                {renderHTML(String(t("termsPage.tableContent.sixteenth.ol1")))}

                <ul className="list-lower-alpha ml-[30px]">
                  <li>
                    {renderHTML(
                      String(t("termsPage.tableContent.sixteenth.ola"))
                    )}
                  </li>
                  <li>
                    {renderHTML(
                      String(t("termsPage.tableContent.sixteenth.olb"))
                    )}
                  </li>
                  <li>
                    {renderHTML(
                      String(t("termsPage.tableContent.sixteenth.olc"))
                    )}
                  </li>
                  <li>
                    {renderHTML(
                      String(t("termsPage.tableContent.sixteenth.old"))
                    )}
                  </li>
                  <li>
                    {renderHTML(
                      String(t("termsPage.tableContent.sixteenth.ole"))
                    )}
                  </li>
                </ul>
              </li>
            </ol>
          </div>
          <p>{renderHTML(String(t("termsPage.tableContent.sixteenth.p2")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.sixteenth.p3")))}</p>
        </div>
      </div>
      <div
        id={"user-data"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          17. {String(t("termsPage.table.t17"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>
            {renderHTML(String(t("termsPage.tableContent.seventeenth.p1")))}
          </p>
          <p>
            {renderHTML(String(t("termsPage.tableContent.seventeenth.p2")))}
          </p>
          <p>
            {renderHTML(String(t("termsPage.tableContent.seventeenth.p3")))}
          </p>
        </div>
      </div>
      <div
        id={"electronic-communications"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          18. {String(t("termsPage.table.t18"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.eighteenth.p1")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.eighteenth.p2")))}</p>
          <p className="font-600">
            {renderHTML(String(t("termsPage.tableContent.eighteenth.p3")))}
          </p>
          <div>
            {renderHTML(String(t("termsPage.tableContent.eighteenth.p4")))}
            <ul className="list-disc list-inside">
              <li>
                {renderHTML(String(t("termsPage.tableContent.eighteenth.ul1")))}
              </li>
              <li className="font-600">
                {renderHTML(String(t("termsPage.tableContent.eighteenth.ul2")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.eighteenth.ul3")))}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        id={"california-users"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          19. {String(t("termsPage.table.t19"))}
        </h2>
        <div className="gap-3 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>{renderHTML(String(t("termsPage.tableContent.nineteenth.p1")))}</p>
          <div>
            <p className="font-600">
              {renderHTML(String(t("termsPage.tableContent.nineteenth.p2")))}
            </p>
            <p className="font-600">
              {renderHTML(String(t("termsPage.tableContent.nineteenth.p3")))}
            </p>
            <ul className="list-disc ml-[30px]">
              <li>
                {renderHTML(String(t("termsPage.tableContent.nineteenth.ul1")))}
              </li>
              <li>
                {renderHTML(String(t("termsPage.tableContent.nineteenth.ul2")))}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        id={"miscellaneous"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          20. {String(t("termsPage.table.t20"))}
        </h2>
        <div className="gap-2 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p> {renderHTML(String(t("termsPage.tableContent.twentieth.p1")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.twentieth.p2")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.twentieth.p3")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.twentieth.p4")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.twentieth.p5")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.twentieth.p6")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.twentieth.p7")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.twentieth.p8")))}</p>
          <p>{renderHTML(String(t("termsPage.tableContent.twentieth.p9")))}</p>
        </div>
      </div>
      <div
        id={"contact-us"}
        className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]"
      >
        <h2 className="text-[20px] md:text-[24px] font-600 uppercase my-[20px]">
          21. {String(t("termsPage.table.t21"))}
        </h2>
        <div className="gap-5 flex flex-col text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          <p>
            {renderHTML(String(t("termsPage.tableContent.twentyFirst.p1")))}
          </p>
          <div className="font-600">
            <p>
              {renderHTML(String(t("termsPage.tableContent.twentyFirst.p2")))}
            </p>
            <p className="flex gap-2 items-center">
              <FaMapPin color="red" />
              <Address>
                {String(t("termsPage.tableContent.twentyFirst.p3"))}
              </Address>
            </p>
            <p className="flex gap-2 items-center">
              <FaMapPin color="red" />
              {renderHTML(String(t("termsPage.tableContent.twentyFirst.p4")))}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
